export function markdownToPlain(markdown: string): string {
  return markdown
    .replace(/!\[.*?\]\(.*?\)/g, "") // remove images
    .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1") // convert links
    .replace(/[*_~`>#-]/g, "") // remove markdown symbols
    .replace(/\n+/g, " ") // flatten newlines
    .trim();
}